import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/settings/exports')({
	component: () => <Outlet />,
	staticData: {
		crumb: ({ context: { L } }) => L.Settings.Exports?.Title?.() || 'Exports'
	}
})
